<script setup>

import Toast from '@/volt/Toast.vue';

import { RouterView, useRoute } from 'vue-router'
import { watch } from 'vue'
import { useEventListener } from '@vueuse/core'
import { useNavigationStore } from '@/stores/navigation.js'
import { useAuthUserStore } from '@/stores/auth.js'
import { tokenService } from '@/services/tokenService.js'
import { recordActivity } from '@/utils/activityTracker.js'

const route = useRoute();
const navigation = useNavigationStore();
const auth = useAuthUserStore();

watch(
    () => auth.getCubejsToken,
    (token) => { if (token) navigation.initReportNodes() }
)

// Track meaningful user input so the auth store can refuse to silently refresh
// sessions that have been idle past the inactivity limit. Capture-phase ensures
// we still see the event if a child component calls stopPropagation.
useEventListener(document, ['mousedown', 'keydown', 'touchstart'], recordActivity, { capture: true, passive: true });

// When the user returns to the tab after a long absence the proactive refresh
// timer may have been throttled or missed entirely by the browser. Re-check
// the token on visibility restore so the session is silently renewed before
// the next API call fails with a 401.
useEventListener(document, 'visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    if (!auth.getLoggedIn) return;
    if (tokenService.isTokenExpiredOrMissing()) {
        auth.silentRefresh();
    }
});

</script>

<template>

  <Toast />
  
  <RouterView :key="route.fullPath" />

</template>

<style></style>
